import { render, staticRenderFns } from "./m-batch-edit-size.vue?vue&type=template&id=0a8a5ce8&scoped=true&"
import script from "./m-batch-edit-size.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-batch-edit-size.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-batch-edit-size.vue?vue&type=style&index=0&id=0a8a5ce8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8a5ce8",
  null
  
)

export default component.exports